import { EpiBlock } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { Button } from '@components';
import { Box, Link, styled, Typography } from '@mui/material';
import { t } from '@translations';
import { lazy, Suspense, useState } from 'react';
// Worker for pdf.js
const PdfPreview = lazy(() =>
  import('./PdfPreview').then((module) => ({ default: module.PdfPreview }))
);

// STYLES
//--------
const PdfCard = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;

  width: 100%;
  .react-pdf__Page__canvas {
    width: 100% !important;
    height: 100% !important;
    aspect-ratio: 0.709;
    object-fit: cover;
  }
  .react-pdf__Document {
    margin-bottom: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    background: white;
  }
  .react-pdf__Page__textContent,
  .react-pdf__Page__annotations {
    display: none;
  }
  .react-pdf__message {
    aspect-ratio: 0.709;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const CustomTitle = styled(Typography)`
  font-size: 18px !important;
  word-break: break-word;
  text-align: center !important;
  font-weight: 600 !important;
  margin-bottom: 8px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  border-bottom: 1px solid #efefef;
`;

const DownloadLink = styled(Link)`
  font-size: 18px !important;
  text-align: center !important;
  font-weight: 400 !important;
  display: inline-block;
`;

export const BrochureItem = ({ block }: EpiBlock) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const title = block?.title || block?.name;
  const downloadLink = block?.url;

  return (
    <PdfCard>
      <Suspense fallback={<div>{t(TextCodes.Base.Loading)}</div>}>
        <PdfPreview file={downloadLink} onLoadSuccess={() => setIsLoaded(true)} />
      </Suspense>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {title && isLoaded && <CustomTitle>{title}</CustomTitle>}
        {downloadLink && isLoaded && (
          <DownloadLink href={downloadLink} download>
            <Button variant='secondary'>{t(TextCodes.Base.Download)}</Button>
          </DownloadLink>
        )}
      </Box>
    </PdfCard>
  );
};
